var _path, _ellipse, _g, _ellipse2, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeMembershipCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 607,
    viewBox: "0 0 429 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2142_680)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2142_680)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.235C0 83.6173 0 41.8087 11.583 20.9043C23.166 0 46.332 0 92.664 0H336.336C382.668 0 405.834 0 417.417 20.9043C429 41.8087 429 83.6173 429 167.235V439.765C429 523.383 429 565.191 417.417 586.096C405.834 607 382.668 607 336.336 607H120.5C74.168 607 23.166 607 11.583 586.096C0 565.191 0 523.383 0 439.765V167.235Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.505,
    cy: 575.504,
    rx: 233.505,
    ry: 233.504,
    fill: "#EFBA80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2142_680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.005 775.081C501.953 775.081 591.083 685.951 591.083 576.003C591.083 466.055 501.953 376.925 392.005 376.925C282.058 376.925 192.927 466.055 192.927 576.003C192.927 685.951 282.058 775.081 392.005 775.081Z",
    stroke: "#BF741E",
    strokeWidth: 19.9577
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2142_680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 342,
    width: 469,
    height: 469
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.497,
    cy: 576.502,
    rx: 233.505,
    ry: 233.504,
    fill: "#EFBA80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.998 776.078C502.945 776.078 592.075 686.948 592.075 577C592.075 467.053 502.945 377.923 392.998 377.923C283.05 377.923 193.92 467.053 193.92 577C193.92 686.948 283.05 776.078 392.998 776.078Z",
    stroke: "#8C5B24",
    strokeWidth: 19.9577
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.497 720.032C395.497 720.641 396.006 721.13 396.614 721.103C448.977 718.801 490.723 675.62 490.723 622.69C490.723 620.257 490.634 617.843 490.46 615.451L490.46 511.573C490.46 510.659 489.395 510.16 488.693 510.745L456.372 537.679C455.853 538.111 455.068 537.965 454.74 537.374L397.516 434.448C396.976 433.476 395.497 433.86 395.497 434.972L395.497 484.597C395.497 484.78 395.543 484.961 395.632 485.121L447.192 577.859C447.52 578.45 448.305 578.596 448.824 578.163L462.423 566.831C463.125 566.246 464.191 566.745 464.191 567.659L464.191 616.457L464.231 616.968C464.378 618.854 464.454 620.762 464.454 622.69C464.454 661.138 434.417 692.571 396.53 694.803C395.954 694.837 395.497 695.311 395.497 695.888L395.497 720.032Z",
    fill: "#8C5B24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M395.497 685.281C395.497 685.902 396.023 686.395 396.641 686.345C424.456 684.092 446.328 660.805 446.328 632.41C446.328 618.899 441.361 606.522 433.174 597.045C433.125 596.989 433.082 596.928 433.046 596.863L397.516 532.958C396.976 531.986 395.497 532.37 395.497 533.481L395.497 583.106C395.497 583.289 395.543 583.469 395.632 583.63L411.552 612.263C411.593 612.338 411.644 612.407 411.702 612.47L412.68 613.53C417.271 618.503 420.059 625.116 420.059 632.41C420.059 646.348 409.817 657.895 396.448 659.934C395.907 660.017 395.497 660.475 395.497 661.021L395.497 685.281Z",
    fill: "#8C5B24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.978 659.934C388.519 660.017 388.929 660.475 388.929 661.021L388.929 685.281C388.929 685.902 388.403 686.395 387.785 686.345C359.97 684.092 338.098 660.805 338.098 632.41C338.098 618.899 343.065 606.522 351.253 597.045C351.301 596.989 351.344 596.927 351.38 596.862L386.91 532.958C387.45 531.986 388.929 532.37 388.929 533.482L388.929 583.106C388.929 583.29 388.883 583.47 388.794 583.63L372.875 612.262C372.833 612.337 372.783 612.407 372.725 612.47L371.746 613.529C367.155 618.503 364.368 625.116 364.368 632.41C364.368 646.348 374.609 657.895 387.978 659.934Z",
    fill: "#8C5B24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M388.929 484.597C388.929 484.78 388.883 484.961 388.794 485.121L337.151 578.009C336.823 578.599 336.038 578.745 335.519 578.313L321.74 566.831C321.038 566.246 319.972 566.745 319.972 567.659L319.972 622.69C319.972 661.138 350.009 692.571 387.896 694.803C388.472 694.837 388.929 695.311 388.929 695.888L388.929 720.032C388.929 720.641 388.42 721.13 387.812 721.103C335.449 718.801 293.703 675.62 293.703 622.69L293.703 511.573C293.703 510.659 294.769 510.16 295.471 510.745L327.971 537.828C328.49 538.261 329.274 538.114 329.603 537.524L386.91 434.448C387.45 433.476 388.929 433.86 388.929 434.972L388.929 484.597Z",
    fill: "#8C5B24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2142_680)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2142_680)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -39.9153,
    x2: 520.106,
    y2: -39.9153,
    transform: "matrix(0.866026 -0.499999 0.500001 0.866025 186.93 685.878)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 79.8307
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2142_680)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -15.9661,
    x2: 520.106,
    y2: -15.9661,
    transform: "matrix(0.866026 -0.499999 0.500001 0.866025 233.641 750.082)",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 31.9323
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_2142_680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.504 719.035C394.504 719.644 395.013 720.133 395.622 720.106C447.985 717.804 489.731 674.623 489.731 621.693C489.731 619.26 489.642 616.846 489.468 614.454L489.468 510.576C489.468 509.662 488.402 509.163 487.7 509.748L455.38 536.682C454.861 537.114 454.076 536.968 453.748 536.377L396.524 433.451C395.984 432.479 394.504 432.863 394.504 433.975L394.504 483.6C394.504 483.783 394.551 483.964 394.64 484.124L446.2 576.862C446.528 577.453 447.313 577.599 447.832 577.166L461.431 565.834C462.133 565.249 463.199 565.748 463.199 566.661L463.199 615.46L463.239 615.971C463.386 617.857 463.461 619.765 463.461 621.693C463.461 660.141 433.425 691.574 395.537 693.806C394.962 693.84 394.504 694.314 394.504 694.89L394.504 719.035Z",
    fill: "#BF741E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.504 684.284C394.504 684.905 395.03 685.398 395.649 685.348C423.464 683.095 445.336 659.808 445.336 631.413C445.336 617.902 440.369 605.525 432.182 596.048C432.133 595.992 432.09 595.931 432.054 595.866L396.524 531.961C395.984 530.989 394.504 531.372 394.504 532.484L394.504 582.109C394.504 582.292 394.551 582.472 394.64 582.633L410.56 611.266C410.601 611.34 410.652 611.41 410.71 611.473L411.688 612.533C416.279 617.506 419.066 624.119 419.066 631.413C419.066 645.351 408.825 656.898 395.455 658.937C394.915 659.02 394.504 659.478 394.504 660.024L394.504 684.284Z",
    fill: "#BF741E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.986 658.937C387.526 659.02 387.937 659.478 387.937 660.024L387.937 684.284C387.937 684.905 387.411 685.398 386.793 685.348C358.977 683.095 337.106 659.808 337.106 631.413C337.106 617.902 342.073 605.524 350.26 596.048C350.309 595.991 350.352 595.93 350.388 595.865L385.917 531.961C386.458 530.989 387.937 531.373 387.937 532.485L387.937 582.109C387.937 582.293 387.89 582.473 387.801 582.633L371.882 611.265C371.841 611.34 371.79 611.41 371.732 611.473L370.754 612.532C366.163 617.505 363.375 624.119 363.375 631.413C363.375 645.351 373.617 656.898 386.986 658.937Z",
    fill: "#BF741E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.937 483.6C387.937 483.783 387.89 483.964 387.801 484.124L336.159 577.012C335.83 577.602 335.046 577.748 334.527 577.316L320.748 565.834C320.046 565.249 318.98 565.748 318.98 566.661L318.98 621.693C318.98 660.141 349.016 691.574 386.904 693.806C387.48 693.84 387.937 694.314 387.937 694.89L387.937 719.035C387.937 719.644 387.428 720.133 386.82 720.106C334.457 717.804 292.711 674.623 292.711 621.693L292.711 510.576C292.711 509.662 293.777 509.163 294.479 509.748L326.979 536.831C327.498 537.264 328.282 537.117 328.611 536.527L385.918 433.451C386.458 432.479 387.937 432.863 387.937 433.975L387.937 483.6Z",
    fill: "#BF741E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2142_680",
    x: -4,
    y: -4,
    width: 437,
    height: 615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2142_680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2142_680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2142_680",
    x: 182.949,
    y: 366.947,
    width: 418.113,
    height: 422.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.99153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.99153
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.478431 0 0 0 0 0.262745 0 0 0 0 0.0156863 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2142_680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2142_680",
    x: 107.099,
    y: 316.775,
    width: 570.171,
    height: 409.019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.9577,
    result: "effect1_foregroundBlur_2142_680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2142_680",
    x: 177.759,
    y: 422.46,
    width: 546.222,
    height: 367.537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.9577,
    result: "effect1_foregroundBlur_2142_680"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_2142_680",
    x: 292.711,
    y: 432.895,
    width: 197.02,
    height: 291.203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.99153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.9873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.479167 0 0 0 0 0.260931 0 0 0 0 0.0159722 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2142_680"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2142_680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 429,
    height: 607,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMembershipCard);
export default __webpack_public_path__ + "static/media/bronze-membership-card.efe5aae803addc0a8f86714a5d172441.svg";
export { ForwardRef as ReactComponent };